import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

/**
 * useActiveSession
 * Fetches the current user's active library session.
 * Re-fetches every 30 seconds. Errors are swallowed — banner hides silently.
 *
 * Returns: { session, loading, error, refetch }
 */
export function useActiveSession() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSession = useCallback(async () => {
    try {
      const res = await api.get('/sessions/active');
      setSession(res.data?.data?.session ?? null);
      setError(null);
    } catch (err) {
      setError(err);
      setSession(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSession();
    const id = setInterval(fetchSession, 30000);
    return () => clearInterval(id);
  }, [fetchSession]);

  return { session, loading, error, refetch: fetchSession };
}
